import { useState } from 'react';

export default function UuidGenerator() {
    const [uuids, setUuids] = useState<string[]>([]);
    const [count, setCount] = useState(1);

    const generateUuid = (): string => {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
            const r = (Math.random() * 16) | 0;
            const v = c === 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    };

    const generate = () => {
        const newUuids = Array.from({ length: count }, () => generateUuid());
        setUuids(newUuids);
    };

    const copyToClipboard = async (text: string) => {
        try {
            await navigator.clipboard.writeText(text);
            alert('Copied to clipboard!');
        } catch (e) {
            alert('Failed to copy');
        }
    };

    const copyAll = async () => {
        try {
            await navigator.clipboard.writeText(uuids.join('\n'));
            alert('All UUIDs copied to clipboard!');
        } catch (e) {
            alert('Failed to copy');
        }
    };

    return (
        <div className="max-w-4xl mx-auto">
            <h1 className="text-3xl font-bold mb-2">UUID Generator</h1>
            <p className="text-gray-600 mb-6">Generate RFC 4122 compliant UUID v4 identifiers</p>

            <div className="tool-card mb-6">
                <div className="flex gap-4 items-end">
                    <div className="flex-1">
                        <label className="font-medium block mb-2">
                            Number of UUIDs to generate
                        </label>
                        <input
                            type="number"
                            min="1"
                            max="100"
                            value={count}
                            onChange={(e) => setCount(Math.max(1, Math.min(100, parseInt(e.target.value) || 1)))}
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg"
                        />
                    </div>
                    <button onClick={generate} className="btn-primary">
                        Generate
                    </button>
                </div>
            </div>

            {uuids.length > 0 && (
                <div className="tool-card">
                    <div className="flex justify-between items-center mb-4">
                        <h2 className="text-xl font-semibold">Generated UUIDs</h2>
                        <button onClick={copyAll} className="btn-secondary">
                            Copy All
                        </button>
                    </div>
                    <div className="space-y-2">
                        {uuids.map((uuid, index) => (
                            <div
                                key={index}
                                className="flex items-center justify-between bg-gray-50 p-3 rounded border border-gray-200"
                            >
                                <code className="font-mono text-sm">{uuid}</code>
                                <button
                                    onClick={() => copyToClipboard(uuid)}
                                    className="text-primary-600 hover:text-primary-700 text-sm font-medium"
                                >
                                    Copy
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            <div className="mt-8 bg-blue-50 border border-blue-200 rounded-lg p-4">
                <h3 className="font-semibold mb-2">About UUID v4</h3>
                <p className="text-sm text-gray-700">
                    UUID (Universally Unique Identifier) v4 are randomly generated 128-bit identifiers.
                    The probability of collision is extremely low, making them suitable for distributed systems
                    without central coordination.
                </p>
            </div>
        </div>
    );
}
